import React from "react";

// Inline SVG flags — cross-platform (Windows Chrome/Edge don't render emoji flags)
const FLAGS = {
  en: (
    <svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
      <clipPath id="hx-uk-c">
        <path d="M0,0 v30 h60 v-30 z" />
      </clipPath>
      <clipPath id="hx-uk-t">
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <g clipPath="url(#hx-uk-c)">
        <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
        <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#hx-uk-t)" stroke="#C8102E" strokeWidth="4" />
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
      </g>
    </svg>
  ),
  de: (
    <svg viewBox="0 0 5 3" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
      <rect width="5" height="3" fill="#000" />
      <rect width="5" height="2" y="1" fill="#D00" />
      <rect width="5" height="1" y="2" fill="#FFCE00" />
    </svg>
  ),
  fr: (
    <svg viewBox="0 0 3 2" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
      <rect width="1" height="2" fill="#002654" />
      <rect width="1" height="2" x="1" fill="#fff" />
      <rect width="1" height="2" x="2" fill="#CE1126" />
    </svg>
  ),
  pt: (
    <svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
      <rect width="240" height="400" fill="#046A38" />
      <rect width="360" height="400" x="240" fill="#DA291C" />
      <circle cx="240" cy="200" r="72" fill="#FFE900" stroke="#046A38" strokeWidth="6" />
      <circle cx="240" cy="200" r="44" fill="#fff" stroke="#046A38" strokeWidth="4" />
    </svg>
  ),
};

export const Flag = ({ code, className = "" }) => {
  const flag = FLAGS[code];
  if (!flag) return null;
  return (
    <span
      className={`inline-block overflow-hidden rounded-[2px] shrink-0 ${className}`}
      style={{ width: "1.1em", height: "0.8em", lineHeight: 0 }}
      aria-hidden="true"
    >
      {flag}
    </span>
  );
};
